import { render, staticRenderFns } from "./cityExpressView.vue?vue&type=template&id=35a9d456&scoped=true&"
import script from "./cityExpressView.vue?vue&type=script&lang=js&"
export * from "./cityExpressView.vue?vue&type=script&lang=js&"
import style0 from "./cityExpressView.vue?vue&type=style&index=0&id=35a9d456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a9d456",
  null
  
)

export default component.exports